import React from "react";
import logo2 from "../Assets/footer-wevend.png";

const Footer = () => {
  return (
    <div className="Footer">
      <img src={logo2} alt="footer" />
    </div>
  );
};

export default Footer;
